import { SparkUsage } from '../BuyTokensModal.styles';

const BuyTokensModalUsage = ({ description, translations }) => {
	if (description) {
		return (
			<SparkUsage>
				<p>{description}</p>
			</SparkUsage>
		);
	}

	return (
		<SparkUsage>
			<p>{translations.usageTitle}</p>
			<span>
				{translations.messageUsage}{' '}
				<strong>{translations.messageUsageValue}</strong>
			</span>
			<span>
				{translations.voiceUsage}{' '}
				<strong>{translations.voiceUsageValue}</strong>
			</span>
			<span>
				{translations.photoUsage}{' '}
				<strong>{translations.photoUsageValue}</strong>
			</span>
			<span>
				{translations.videoUsage}{' '}
				<strong>{translations.videoUsageValue}</strong>
			</span>
			<span>
				{translations.characterUsage}{' '}
				<strong>{translations.characterUsageValue}</strong>
			</span>
		</SparkUsage>
	);
};

export default BuyTokensModalUsage;
